export function getOffsetTopToParent(
    childDiv: HTMLElement,
    parentDiv: HTMLElement
) {
    let offsetTop = 0
    let currentElement = childDiv

    while (currentElement && currentElement !== parentDiv) {
        offsetTop += currentElement.offsetTop
        const parent = currentElement.offsetParent
        if (!parent || !(parent instanceof HTMLElement)) {
            throw new Error("Parent not found or not HTMLElement")
        }
        currentElement = parent
    }

    // If the loop completed without finding the parentDiv, return null.
    if (!currentElement) {
        throw new Error("parentDiv not found")
    }

    return offsetTop
}
